import React, { Component }          from 'react';
import axios                         from 'axios';
import Admins                        from './Admins';
import Locations                     from './Locations';
import Recordings                    from './Recordings';
import warholLogo                    from '../../img/warhol-logo.svg';
import icUser                        from '../../img/ic_user.svg';
import icHamburger                   from '../../img/ic_hamburger.svg';
import "./Dashboard.scss";
import ExportRecordingsDialog from './dialogs/ExportRecordingsDialog';
import AdminDialog from './dialogs/AdminDialog';
import LocationsDialog from './dialogs/LocationsDialog';
import DeleteDialog from './dialogs/DeleteDialog';
import network from '../common/Network';
import SearchRecordings from './dialogs/SearchRecordingsDialog';
import MobileMenu from './MobileMenu';
import { STATES } from '../home/Home';
import { ROLES } from '../common/Common';
import { IndeterminateProgress } from '../common/IndeterminateProgress';

const SCREENS = {
    RECORDINGS: "RECORDINGS",
    LOCATIONS: "LOCATIONS",
    ADMINS: "ADMINS",
}

const DIALOG_STATES = {
  IDLE: 'IDLE',
  DELETE_LOCATION: 'DELETE_LOCATION',
  RESEND_RECORDING_LINK: 'RESEND_RECORDING_LINK',
  DELETE_RECORDING: 'DELETE_RECORDING',
}

const LAMBDA_AUTH_KEY = "f982j0efj0sd9jf029j3fslidjfjhg928";
const MAX_EXPORT_RECORDINGS = 500;

class Dashboard extends Component {

  constructor(props) {
    super(props);

    this.state            = {
        currentState: SCREENS.RECORDINGS,
        admins: [],
        locations: [],
        recordings: [],
        showAdminDialog: false,
        editingAdmin: null,
        editingLocation: null,
        showLocationsDialog: false,
        showConfirmDialog: false,
        showSearchRecordingsDialog: false,
        showExportRecordingsDialog: false,
        exportInProgress: false,
        dialogText: '',
        dialogState: DIALOG_STATES.IDLE,
        selectedRecording: null,
        recordingSearchParams: {},
        searchRecordingResults: [],
        showUserMenu: false,
        showMobileMenu: false,
        showProgress: false,
        locationFilter: -1,
        searchPage: 0,
        pages: {
          [SCREENS.RECORDINGS]: 0,
          [SCREENS.LOCATIONS]: 0,
          [SCREENS.ADMINS]: 0,
        },
        maxResults: {
          [SCREENS.RECORDINGS]: 1000,
          [SCREENS.LOCATIONS]: 1000,
          [SCREENS.ADMINS]: 1000,
        }
    }
  }

  componentDidMount() {
    this.updateAdmins();
    this.updateLocations();
    this.updateRecordings();
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentState === STATES.DASHBOARD) {
      if (window.location.hash === "#/") {
        this.changeScreen(SCREENS.RECORDINGS);
      } else {
        const hash = window.location.hash;
        const currentLocation = hash.includes("#/admin/dashboard") ? hash.replace("#/admin/dashboard/", "") : SCREENS.RECORDINGS;
        console.log(`SET: ${hash} ${currentLocation}`)
        if (currentLocation !== this.state.currentState) {
          window.location.href = `/#/admin/dashboard/${currentLocation}`
          this.changeScreen(currentLocation);
        }
      }
    }

    if (prevProps.currentState === STATES.LOGIN && this.props.currentState === STATES.DASHBOARD) {
      this.updateAdmins();
      this.updateLocations();
      this.updateRecordings();
    }
  }

  updateAdmins(pageIndex=0) {
    if (this.props.role === ROLES.ADMIN) {
      axios.get(`/api/admins?=${pageIndex}`).then(response => {
        const maxResults = this.state.maxResults;
        maxResults[SCREENS.ADMINS] = response.data.count;
        this.setState({admins: response.data.rows, maxResults, showProgress: false})
      }).catch(e => {
        console.log(e);
        this.setState({showProgress: false})
      })
    }
  }

  updateLocations(pageIndex=0) {
    axios.get(`/api/locations?page=${pageIndex}`).then(response => {
      const maxResults = this.state.maxResults;
      maxResults[SCREENS.LOCATIONS] = response.data.count;
      this.setState({locations: response.data.rows || [], maxResults, showProgress: false})
    }).catch(e => {
      console.log(e);
      this.setState({showProgress: false})
    })
  }

  setShowProgress(showProgress) {
    this.setState({showProgress})
  }

  updateRecordings(pageIndex=0) {
    const locationFilter = this.state.locationFilter > -1 ? `&locationId=${this.state.locationFilter}` : ""
    axios.get(`/api/recordings?page=${pageIndex}${locationFilter}`).then(response => {
      if (response.data) {
        const maxResults = this.state.maxResults;
        maxResults[SCREENS.RECORDINGS] = response.data.count;
        this.setState({recordings: response.data.rows, maxResults, showProgress: false })
      }
    }).catch(e => {
      console.log(e);
      this.setState({showProgress: false})
    })
  }

  saveLocation(location) {
    let request = null;
    const formData = new FormData();
    const formKeys = Object.keys(location);
    for (let i = 0; i < formKeys.length; i++) {
      formData.append(formKeys[i], location[formKeys[i]]);
    }

    console.log(formData)
    console.log(location)
    if (location.id !== undefined) {
      request = axios.put(`/api/locations/${location.id}`, formData)
    } else {
      request = axios.post("/api/locations", formData)
    }
    request.then(() => {
      this.updateLocations();
      this.closeDialog();
    }).catch(e => {
      console.log(e);
    });
  }

  saveAdmin(admin) {
    let request = null;
    if (admin.id !== undefined) {
      request = axios.put(`/api/admins/${admin.id}`, admin)
    } else {
      request = axios.post("/api/admins", admin)
    }
    request.then(() => {
      this.updateAdmins();
      this.closeDialog();
    }).catch(e => {
      console.log(e);
    });
  }

  handleLogout() {
    network.post("/api/logout")
      .then(() => {
        this.setState({showUserMenu: false, showMobileMenu: false});
        this.props.navigateTo(STATES.LOGIN);
      });
  }

  filterSearchRecordings(searchParams, pageIndex=0) {
    this.closeDialog();
    this.setState({recordingSearchParams: searchParams, searchPage: pageIndex});
    network.post(`/api/recordings/search?page=${pageIndex}`, searchParams)
      .then(response => {
        this.setState({searchRecordingResults: response.data.rows, recordingSearchMaxResults: response.data.count, showProgress: false});
      })
  }

  changeScreen(screen) {
    window.location.href = `/#/admin/dashboard/${screen}`
    if (screen === SCREENS.ADMINS) {
      this.updateAdmins();
    }
    this.setState({currentState: screen, showMobileMenu: false});
  }

  hasSearchParams() {
    return this.state.recordingSearchParams && Object.keys(this.state.recordingSearchParams).length > 0;
  }

  updatePage(screen, nextPageIndex) {
    const pages = this.state.pages;
    if (screen === SCREENS.RECORDINGS) {
      if (this.hasSearchParams()) {
        this.filterSearchRecordings(this.state.recordingSearchParams, nextPageIndex)
        this.setState({searchPage: nextPageIndex, showProgress: true})
      } else {
        this.updateRecordings(nextPageIndex);
        pages[screen] = nextPageIndex;
        this.setState({pages, showProgress: true})
      }
    } else if (screen === SCREENS.LOCATIONS) {
      this.updateLocations(nextPageIndex);
      pages[screen] = nextPageIndex;
      this.setState({pages, showProgress: true})
    } else {
      this.updateAdmins(nextPageIndex);
      pages[screen] = nextPageIndex;
      this.setState({pages, showProgress: true})
    }
  }

  decrementPage(screen) {
    if (this.hasSearchParams() && screen === SCREENS.RECORDINGS) {
      const nextPageIndex = this.state.searchPage - 1
      if (nextPageIndex >= 0) {
        this.filterSearchRecordings(this.state.recordingSearchParams, nextPageIndex)
      }
    } else {
      const nextPageIndex = this.state.pages[screen] - 1
      if (nextPageIndex >= 0) {
        this.updatePage(screen, nextPageIndex)
      }
    }
  }

  incrementPage(screen) {
    if (this.hasSearchParams() && screen === SCREENS.RECORDINGS) {
      let nextPageIndex = this.state.searchPage + 1;
      let nextItemIndex = nextPageIndex * 8;
      if (nextItemIndex <= this.state.recordingSearchMaxResults) {
        this.filterSearchRecordings(this.state.recordingSearchParams, nextPageIndex)
      }
    } else {
      let nextPageIndex = this.state.pages[screen] + 1
      let nextItemIndex = nextPageIndex * 8;
      if (nextItemIndex <= this.state.maxResults[screen] + 1) {
        this.updatePage(screen, nextPageIndex)
      }
    }
  }

  showEditAdminDialog(admin) {
    this.setState({showAdminDialog: true, editingAdmin: admin})
  }

  showDeleteLocationDialog(location) {
    this.setState({showConfirmDialog: true, locationToDelete: location, dialogState: DIALOG_STATES.DELETE_LOCATION})
  }

  showResendRecordingDialog(recording) {
    this.setState({showConfirmDialog: true, selectedRecording: recording, dialogState: DIALOG_STATES.RESEND_RECORDING_LINK})
  }

  showDeleteRecordingDialog(recording) {
    this.setState({showConfirmDialog: true, selectedRecording: recording, dialogState: DIALOG_STATES.DELETE_RECORDING})
  }

  showAddAdminDialog() {
    this.setState({showAdminDialog: true, editingAdmin: null})
  }

  isDialogShowing() {
    return this.state.showAdminDialog || this.state.showLocationsDialog || this.state.showConfirmDialog;
  }

  closeDialog() {
    this.setState({
      showConfirmDialog: false, showAdminDialog: false, showLocationsDialog: false,
      editingAdmin: null, editingLocation: null, locationToDelete: null, selectedRecording: null,
      showSearchRecordingsDialog: false, showExportRecordingsDialog: false
    });
  }

  dismissUserMenu() {
    this.setState({showUserMenu: false})
  }

  showLocationsDialog() {
    this.setState({showLocationsDialog: true, editingAdmin: null});
  }

  requestShowSearchRecordings() {
    this.setState({showSearchRecordingsDialog: true});
  }

  clearSearchParams() {
    this.setState({recordingSearchParams: {}, searchRecordingResults: []})
  }

  showEditLocationsDialog(location) {
    this.setState({showLocationsDialog: true, editingLocation: location});
  }

  sendPasswordSetEmail(admin) {
    network.post("/api/forgot-password-requests", {email: admin.email})
  }

  onConfirmDelete() {
    if (this.state.dialogState === DIALOG_STATES.DELETE_LOCATION && this.state.locationToDelete) {
      axios.delete(`/api/locations/${this.state.locationToDelete.id}`)
        .then(() => {
          this.closeDialog();
          this.updateLocations();
        })
        .catch(e => {
          this.closeDialog();
        }).finally(() => {

        })
    } else if (this.state.dialogState === DIALOG_STATES.DELETE_RECORDING && this.state.selectedRecording) {
      network.delete(`/api/recordings/${this.state.selectedRecording.id}`)
        .then(() => {
          this.updateRecordings();
          this.closeDialog();
      })
    } else if (this.state.dialogState === DIALOG_STATES.RESEND_RECORDING_LINK && this.state.selectedRecording) {
        network.post(`/api/recordings/${this.state.selectedRecording.id}/resend-email`, {access_key: this.state.selectedRecording.Location.accessKey})
          .then(() => this.closeDialog())
    }
  }

  onDenyDelete() {
    this.closeDialog();
  }

  getDialogText() {
    if (this.state.dialogState === DIALOG_STATES.DELETE_LOCATION) {
      return 'Are you sure you want to delete this location?';
    } else if (this.state.dialogState === DIALOG_STATES.DELETE_RECORDING) {
      return 'Are you sure you want to delete this recording?';
    } else if (this.state.dialogState === DIALOG_STATES.RESEND_RECORDING_LINK) {
      return 'Are you sure you want to resend the link to this recording?';
    }
    return '';
  }

  renderTab(screenType, tabName) {
    if (screenType === SCREENS.ADMINS) {
      if (this.props.role === "ADMIN") {
        return <div onClick={() => this.changeScreen(screenType)} className={`menu-item ${this.state.currentState === screenType ? 'selected' : ''}`}>{tabName}</div>
      } else {
        return "";
      }
    }
    return <div onClick={() => this.changeScreen(screenType)} className={`menu-item ${this.state.currentState === screenType ? 'selected' : ''}`}>{tabName}</div>
  }

  exportRecordings() {
    if (!this.state.exportInProgress) {
      this.setState({exportInProgress: true, exportUrl: ""});
      network.post("/api/recordings/export", this.state.recordingSearchParams)
        .then(response => {
          if (response.data.count > 0) {
            const keys = response.data.rows.map(r => r.url)
            const names = response.data.rows.map(r => {
              return `${r.email}-${new Date(r.date).toISOString()}`
            })
            axios.post("/api/lambda", {
                "auth": LAMBDA_AUTH_KEY,
                "keys": keys,
                "names": names,
              }).then((lambdaResponse) => {
              if (lambdaResponse.data.url) {
                this.setState({exportInProgress: false, exportUrl: lambdaResponse.data.url});
              } else {
                this.setState({exportInProgress: false});
              }
            })
          } else {
            this.setState({exportInProgress: false});
            alert("No data available to export.")
          }
        })
    }
  }


  downloadCSVFile(link) {
    fetch(link, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    })
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `users.csv`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
  }

  render() {
    return (
      <div className={`dashboard__container ${this.props.currentState === "DASHBOARD" ? 'show' : ''}`}>
        <div className={`main-container ${this.isDialogShowing() ? 'blur' : ''}`}>
          <div className="mobile-header">
            <div className="mobile-header-title">Screen Test Admin</div>
            <img onClick={() => this.setState({showMobileMenu: true})} src={icHamburger} />
          </div>
          <div className="title-bar">
              <img src={warholLogo}/>
              <div className="icons">
                <img onClick={() => this.setState({showUserMenu: true})} src={icUser} />
                <div className={`user-menu ${this.state.showUserMenu ? 'show' : ''}`}>
                  <div onClick={this.handleLogout.bind(this)} className="item">Logout</div>
                </div>
              </div>
          </div>
          <div className="menu-bar">
              {this.renderTab(SCREENS.RECORDINGS, 'Recordings')}
              {this.renderTab(SCREENS.LOCATIONS, 'Locations')}
              {this.renderTab(SCREENS.ADMINS, 'Admins')}
          </div>
          <div className="main-content">
            <Admins
              currentPage={this.state.pages[SCREENS.ADMINS]}
              maxResults={this.state.maxResults[SCREENS.ADMINS]}
              decrementPage={this.decrementPage.bind(this)}
              incrementPage={this.incrementPage.bind(this)}
              sendPasswordSetEmail={this.sendPasswordSetEmail.bind(this)}
              showAddDialog={this.showAddAdminDialog.bind(this)}
              showEditDialog={this.showEditAdminDialog.bind(this)}
              admins={this.state.admins}
              setShowProgress={this.setShowProgress.bind(this)}
              currentState={this.state.currentState} />
            <Locations
              currentPage={this.state.pages[SCREENS.LOCATIONS]}
              maxResults={this.state.maxResults[SCREENS.LOCATIONS]}
              decrementPage={this.decrementPage.bind(this)}
              incrementPage={this.incrementPage.bind(this)}
              showDeleteDialog={this.showDeleteLocationDialog.bind(this)}
              showAddDialog={this.showLocationsDialog.bind(this)}
              showEditDialog={this.showEditLocationsDialog.bind(this)}
              locations={this.state.locations}
              setShowProgress={this.setShowProgress.bind(this)}
              currentState={this.state.currentState} />
            <Recordings
              downloadCSVFile={this.downloadCSVFile.bind(this)}
              searchPage={this.state.searchPage}
              maxSearchResults={this.state.recordingSearchMaxResults}
              currentPage={this.state.pages[SCREENS.RECORDINGS]}
              maxResults={this.state.maxResults[SCREENS.RECORDINGS]}
              decrementPage={this.decrementPage.bind(this)}
              incrementPage={this.incrementPage.bind(this)}
              showDeleteRecordingDialog={this.showDeleteRecordingDialog.bind(this)}
              locations={this.state.locations}
              locationFilter={this.state.locationFilter}
              setLocationFilter={(_locationFilter) => {
                this.setState({locationFilter: _locationFilter}, () => this.updateRecordings())
              }}
              clearSearchParams={this.clearSearchParams.bind(this)}
              searchParams={this.state.recordingSearchParams}
              searchResults={this.state.searchRecordingResults}
              showExportRecordingsDialog={() => {
                if (this.state.recordingSearchMaxResults <= MAX_EXPORT_RECORDINGS) {
                  this.setState({
                    showExportRecordingsDialog: true,
                    exportUrl: ""
                  })
                } else {
                  alert(`Please select less than ${MAX_EXPORT_RECORDINGS} search results to export.`)
                }
              }}
              showSearchDialog={this.requestShowSearchRecordings.bind(this)}
              showResendRecordingDialog={this.showResendRecordingDialog.bind(this)}
              recordings={this.state.recordings}
              setShowProgress={this.setShowProgress.bind(this)}
              currentState={this.state.currentState} />
          </div>
        </div>
        <ExportRecordingsDialog
          title={`Would you like to export ${this.state.recordingSearchMaxResults} recordings?`}
          exportInProgress={this.state.exportInProgress}
          show={this.state.showExportRecordingsDialog}
          exportUrl={this.state.exportUrl}
          export={this.exportRecordings.bind(this)}
          closeDialog={this.closeDialog.bind(this)}/>
        <SearchRecordings
          filterResults={this.filterSearchRecordings.bind(this)}
          locations={this.state.locations}
          show={this.state.showSearchRecordingsDialog}
          closeDialog={this.closeDialog.bind(this)}/>
        <AdminDialog
          locations={this.state.locations}
          saveAdmin={this.saveAdmin.bind(this)}
          editingAdmin={this.state.editingAdmin}
          show={this.state.showAdminDialog}
          closeDialog={this.closeDialog.bind(this)}/>
        <LocationsDialog
          saveLocation={this.saveLocation.bind(this)}
          editingLocation={this.state.editingLocation}
          show={this.state.showLocationsDialog}
          closeDialog={this.closeDialog.bind(this)}/>
        <DeleteDialog
          onConfirm={this.onConfirmDelete.bind(this)}
          onDeny={this.onDenyDelete.bind(this)}
          text={this.getDialogText()}
          show={this.state.showConfirmDialog}
          closeDialog={this.closeDialog.bind(this)}/>
          <div onClick={this.dismissUserMenu.bind(this)} className={`user-menu-click-target ${this.state.showUserMenu ? 'show' : ''}`}></div>
        <MobileMenu
          handleLogout={this.handleLogout.bind(this)}
          changeScreen={this.changeScreen.bind(this)}
          hideMobileMenu={() => this.setState({showMobileMenu: false})}
          show={this.state.showMobileMenu} />
        <IndeterminateProgress show={this.state.showProgress} />
      </div>
    );
  }
}

export default Dashboard;